import { InfoText } from "@/components/info-text/src";
import { CallOutComponent as CallOutComponentType } from "@/templates/agile-hub/types";

export type CallOutComponentProps = Omit<CallOutComponentType, "__typename">;
export const CallOutComponent = (data: CallOutComponentProps) => (
    <InfoText
        text={data.callOutText as string}
        type="html"
        headingText={data.title as string}
    />
);
